<template>
  <University />
</template>

<script>
import University from '@/components/common/university/index.vue'

export default {
  name: 'UniversityChoosingPage',
  components: {
    University
  }
}
</script>

<style scoped>

</style>
